import styles from "../../../src/styles/AddComponent/add.module.css";

const AddContainer = () => {
  return (
    <div className={styles.addContainer}>
      <div className={styles.addAbsolute}>Ad</div>
      <div>Want to post a add here?</div>
      <div>
        <a href="mailto:support@lovencoders.com">
          <button className={styles.adBtn}>Contact Us</button>
        </a>
      </div>
    </div>
  );
};

export default AddContainer;
